export default __webpack_public_path__ + "static/media/icon-fleet.faea4e95.svg";